'use es6';

import { createSelector } from 'reselect';
import { getHasEitherTestCreationAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getIsAnyTestRunning } from 'ContentEditorUI/redux/selectors/mabExperimentSelectors';
export const getIsMABorABCreatable = createSelector([getHasEitherTestCreationAccess, getIsAnyTestRunning], (hasEitherTestCreationAccess, isAnyTestRunning) => hasEitherTestCreationAccess && !isAnyTestRunning);